import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./CreateProductForm";
import {LIST_PRODUCT_TYPES} from "../../../queries/inventory";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {cancelCreateProduct} from "../../../actions/InventoryApiActions";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";
import {validatePresence, validateGreaterThan} from "../../../lib/Validators";
import {fromJS, Map} from "immutable";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "type");
  errors = validatePresence(errors, values, "sku");
  errors = validatePresence(errors, values, "title");
  errors = validateGreaterThan(errors, values, "weight", 0);
  errors = validateGreaterThan(errors, values, "width", 0);
  errors = validateGreaterThan(errors, values, "height", 0);
  errors = validateGreaterThan(errors, values, "depth", 0);  
  return errors.toJS();
}

class CreateProductFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.createProduct(values.toJS())
      .then((response) => {
        if (response.data.createProduct.errors.length <= 0) {
          this.props.cancelCreateProduct();
        } else {
          let errors = createValidationErrors(response.data.createProduct.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        console.warn(err);
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelCreateProduct();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    return (
      <Form
        errors={this.state.errors}
        validate={validateForm}
        productTypes={fromJS(data.productTypes)}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const CREATE_PRODUCT = gql`
  mutation createProduct($data: ProductInput!) {
    createProduct(input: $data) {
      errors { key message }
    }
  }
`;

const withProductQuery = compose(
  graphql(LIST_PRODUCT_TYPES, {
    options: {
      fetchPolicy: "network-only"
    }    
  }),
  graphql(CREATE_PRODUCT, {
    props: ({ mutate }) => ({
      createProduct: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

const CreateProductFormContainerWithData = withProductQuery(CreateProductFormContainer);



export default connect(null, {cancelCreateProduct})(CreateProductFormContainerWithData);